import PrimaryButton from 'components/common/PrimaryButton';
import React from 'react'
import styles from 'styles/components/ReportCategoryHero.module.sass'

/**
 * A component that displays a hero section with a list of report categories.
 *
 * @param {ReportCategory[]} props.categories - The list of report categories to display in the hero section.
 * @returns {React.ReactElement} A rendered `ReportCategoryHero` component.
 * 
 * @example
 * <ReportCategoryHero />
 */
const ReportCategoryHero: React.FC = () => {
    const handleExploreClick = () => {
        const target = document.getElementById('report-categories-item-section')
        if (target) {
            target.scrollIntoView({ behavior: 'smooth' })
        }
    }

    return (
        <div className={styles['report-category-hero']}>
            <p className={styles['hero-title']}>Explore and Purchase Trusted Data rich Reports</p>
            <p className={styles['hero-subtitle']}>Access a wide range of expert insights across key sectors. Browse by category, search by keyword, and instantly purchase the reports that matter to your business.</p>
            <PrimaryButton 
                text={'Explore Our Reports'} 
                primaryColor={'#FF5522'} 
                textColor={'#FFFFFF'} 
                hoverColor={'#FFFFFF'} 
                hoverTextColor={'#FF5522'}
                icon={'solar:arrow-right-linear'}
                doSomething={handleExploreClick}
            />
        </div>
    )
}

export default ReportCategoryHero;